import React from 'react';
import CustomCursor from '../CustomCursor';
import { useMousePosition } from '../../hooks';

import { HoverConsumer } from '../../context';

const CustomCursorContainer = () => {
    const { documentLeft } = useMousePosition();
    return <HoverConsumer>{render => <CustomCursor {...{ documentLeft, context: render.context }} />}</HoverConsumer>;
};

export default CustomCursorContainer;
